module.exports = __webpack_public_path__ + "static/media/18ECA48.1e706dd7.jpg";